import React from 'react';
import RoadmapTimeline from './components/RoadmapTimeline';

export default function AIDataEngineerRoadmapDisplay({ roadmap, maxMonth, isUnlocked, roleKey }) {
  return (
    <RoadmapTimeline
      roadmap={roadmap}
      title={`Your ${roadmap?.totalMonths || 6}-Month AI/Data Engineer Career Roadmap`}
      subtitle="AI & Data Engineering Journey"
      maxMonth={maxMonth}
      isUnlocked={isUnlocked}
      fileName="tekyu-ai-data-engineer-roadmap.pdf"
      roleKey={roleKey || "aidataengineer"}
    />
  );
}